var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgResumeIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_26901",
    "data-name": "Group 26901",
    transform: "translate(-5327 8478)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_6239",
    "data-name": "Rectangle 6239",
    transform: "translate(5327 -8478)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Union_241",
    "data-name": "Union 241",
    d: "M403.619,1150.64a1.934,1.934,0,0,1-.619-1.42v-12.239a2.017,2.017,0,0,1,1.938-1.979l.077,0a1.909,1.909,0,0,1,.935.243l11.044,6.119a2.006,2.006,0,0,1,0,3.476l-11.044,6.12a1.916,1.916,0,0,1-.935.242A2.063,2.063,0,0,1,403.619,1150.64Zm1.157-14.015a.4.4,0,0,0-.185.355v12.239a.377.377,0,0,0,.37.406.451.451,0,0,0,.218-.06l11.045-6.119a.379.379,0,0,0,0-.692l-11.045-6.12a.453.453,0,0,0-.217-.058A.362.362,0,0,0,404.777,1136.625Z",
    transform: "translate(4928.501 -9609.1)",
    fill: "#fd581f"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResumeIcon);
export default __webpack_public_path__ + "static/media/resumeIcon.db160dd37839a2b0e0d97a81652d1398.svg";
export { ForwardRef as ReactComponent };